import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface CheckoutState {
  /** True while the create-order request is in flight. */
  placing: boolean;
  emailValidation: string | null;
  emailValidationError: string | null;
}

const initialState: CheckoutState = {
  placing: false,
  emailValidation: null,
  emailValidationError: null,
};

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setPlacing(state, action: PayloadAction<boolean>) {
      state.placing = action.payload;
    },
    setEmailValidation(state, action) {
      state.emailValidation = action.payload;
    },
    setEmailValidationError(state, action) {
      state.emailValidationError = action.payload;
    },
  },
});

export const { setPlacing, setEmailValidation, setEmailValidationError } =
  checkoutSlice.actions;

export default checkoutSlice.reducer;
